<template>
  <div class="animated fadeIn">
    <!-- <b-row v-if="editorDataLoaded">
      <b-col lg="12" v-if="!formData.is_matched && formData.form_doc_status !== 'stage_1'">
        <b-alert show variant="warning">
          {{ $t('FORMS.MSG_WARN') }} ({{ formData.rejection_reason }})
        </b-alert>
      </b-col>
    </b-row> -->
    <b-row>
      <b-col>
        <div class="heading">
          <b-row  align-v="center">
            <b-col sm="2">
              <router-link v-if="next_form_id" :to="{ name: 'Verification', params: {id: next_form_id }}">
                <b-button variant="secondary">
                  {{ $t('FORMS.NEXT_FORM') }}
                </b-button>
              </router-link>
            </b-col>
            <b-col sm="8">
              <b-row align-v="center" align-h="center">
                <b-col sm="6" >
                  <h3 class="ellipsis" v-b-tooltip.hover.d100.topleft :title="this.formData.title">{{$t('COMMON.FORM')}}: {{ formData.title }}</h3>
                </b-col>
                <b-col >
                    <div class="paginate-page float-left">
                      <b-button v-b-tooltip.hover title='Go to previous page' :variant="'link'" :disabled="canGoToPrev" @click="saveAndGoToPage(prevPage)" ><i class="fa fa-arrow-left" v-b-tooltip.hover></i></b-button>
                      <span><span class="h4">{{getCurrentPage}}</span> {{ $t('COMMON.OF') }} {{totalPages}}</span>
                      <b-button v-b-tooltip.hover title='Go to next page' :variant="'link'" :disabled="canGoToNext" @click="saveAndGoToPage(nextPage)" ><i class="fa fa-arrow-right" v-b-tooltip.hover></i></b-button>
                    </div>
                  </b-col>
              </b-row>
            </b-col>
            <b-col sm="2">
              <router-link v-if="prev_form_id" :to="{ name: 'Verification', params: {id: prev_form_id }}">
                <b-button variant="secondary" class="float-right">
                  {{ $t('FORMS.PREV_FORM') }}
                </b-button>
              </router-link>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-card v-if="processedDataLoaded && formData.template_id === '-7'">
      <div class="p-2">
        <strong>{{ $t('FORMS.PROCESSED_DATA') + ':' }}</strong>
        <div class="pull-right">
          <b-button class="ml-1 mr-1" variant="primary" size="sm" @click="saveData(true)" :disabled="(updatedPEVIds.length === 0) || (!checkauth)">
            <i class="fa fa-save"></i>&nbsp;{{ $t('COMMON.SAVE') }}
          </b-button>
          <b-button size="sm" variant="success" @click="acceptFormDoc()" v-if="this.docStatus !== 'unmatched'&&checkauth && Object.keys(this.allPageIdMap).length > 1">
            <i class="fa fa-check"> </i> <span> {{ processDone }} All </span>
          </b-button>
          <b-button class="ml-1 mr-1" variant="success" size="sm" @click="acceptForm" :disabled="this.docStatus === 'unmatched'&&!checkauth">
            <i class="fa fa-check"></i>&nbsp;{{ processDone }}
          </b-button>
        </div>
      </div>
      <div class="excel-workbook" v-if="tableHeaders.length > 0">
        <table v-if="formData.processed_tree_data.headers" class="stick-table">
          <thead>
            <th v-for="(header, index) in tableHeaders" :key=index>{{ header }}</th>
          </thead>
          <tbody>
            <tr v-for="(entry, pev_id) in updatedPEVs" :key=pev_id>
              <td v-for="(header, index) in tableHeaders" :key=index>
                <span v-if="editedPEV(pev_id, header)">
                  <input class="table-input table-input-edited" @change="updateExcelData($event, pev_id, header)" :value="entry[header]" v-b-tooltip.hover :title="'Original Value: ' + originalPEVs[pev_id][header]"/>
                </span>
                <span v-else>
                  <input class="table-input" @change="updateExcelData($event, pev_id, header)" :value="entry[header]"/>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="no-excel-data" v-else>
        {{ $t('FORMS.NO_LINE_ITEMS') }}
      </div>
    </b-card>
    <b-card class="p-4" v-else>
      <b-row>
        <b-col lg="4">
          <b-card class="process-data p-2">
            <div slot="header">
              <strong>{{ $t('FORMS.PROCESSED_DATA') }}</strong>
              <div class="float-right" v-if="processedDataLoaded">
                <b-button size="sm" variant="primary" @click="showSignInvoice()" v-if="shouldShowSignInvoice && checkauth">
                  <i class="fa fa-pencil"> </i> <span> {{ $t('INVOICE.SIGN') }} </span>
                </b-button>
                <b-button size="sm" variant="primary" @click="showSignInvoice()" v-if="shouldShowApproveInvoice && checkauth">
                  <i class="fa fa-pencil"> </i> <span> {{ $t('INVOICE.APPROVE') }} </span>
                </b-button>
                <b-button v-b-tooltip.hover title="Expand All Sections" size="sm" variant="primary" @click="expandAllSections" v-if="hideExpandCollapse">
                  <span> <i class="fa fa-expand" aria-hidden="true"></i> </span>
                </b-button>
                <b-button v-b-tooltip.hover title="Collapse All Sections" size="sm" variant="primary" @click="collapseAllSections" v-if="hideExpandCollapse">
                  <span> <i class="fa fa-compress" aria-hidden="true"></i> </span>
                </b-button>
                <!-- <b-button size="sm" variant="success" @click="acceptFormDoc()" v-if="this.docStatus !== 'unmatched'&&checkauth && Object.keys(this.allPageIdMap).length > 1">
                  <i class="fa fa-check"> </i> <span> {{ processDone }} All </span>
                </b-button> -->
                <b-button size="sm" variant="danger" v-on:click="showRejectFormModal">
                  <i class="fa fa-check"> </i> <span> Reject </span>
                </b-button>
                <b-button size="sm" variant="success" @click="exportSalesforce()" :disabled="!this.exportFormFlag">
                  <i class="fa fa-check"> </i> <span> {{ processDone }} </span>
                </b-button>
              </div>
              <div>
                <input type="text" class="form-control" :placeholder="$t('FORMS.SERACH_PLACEHOLDER')" v-model="processValueText">
              </div>
              <div class="float-right add-field-btn" v-if="processedDataLoaded && this.formData.is_ins_card">
                <b-button type="submit" size="sm" variant="primary" v-b-modal.newField>
                  <i class="fa fa-plus"> </i> <span> {{$t('FORMS.ADD_FIELD')}} </span>
                </b-button>
              </div>
            </div>
            <div class="d-flex justify-content-center mt-3"  v-if="formData.form_doc_status === 'unmatched' && !this.processData.children > 0 && showAddDataButton">
              <b-button @click="manualData">Add Data Manually</b-button>
            </div>
            <div class="range-slider" v-if="processedDataLoaded">
              <input @change="slider" v-model="minConf" min="0" max="100" step="1" type="range" />
              <input @change="slider" v-model="maxConf" min="0" max="100" step="1" type="range" />
              <span>{{ $t('FORMS.CONF_RANGE') }} : {{minConf}} - {{maxConf}}</span>
            </div>
            <div v-on:scroll.passive="handleScroll" class="scrollable-content" v-bind:style="{ maxHeight: this.scrollHeight + 'px' }">
              <content-placeholders v-if="!processedDataLoaded">
                <content-placeholders-text :lines="29" />
                </content-placeholders>
                <processed-data-tree v-else v-bind:min-conf="this.minConf" v-bind:max-conf="this.maxConf" v-bind:processedData="this.processData" v-bind:autoCorrectFlag="this.formData.template_auto_correct_flag" v-bind:dataBus="this.dataBus" :isInsCard="this.formData.is_ins_card" :imgBase="this.imgBase" :imgUrl="this.formData.image_url" v-bind:dataPresent="this.dataPresent" v-bind:currentPage="this.getCurrentPage" v-bind:docStatus="this.docStatus"></processed-data-tree>
            </div>
            <div slot="footer" v-if="appMode === 'service'">
              <b-row>
                <b-button class="col-1 m-1 pull-left service-btn" size="sm" variant="secondary" :disabled="canGoToPrev" @click="saveAndGoToPage(prevPage)"><i class="fa fa-angle-double-left" v-b-tooltip.hover title="Prev Page"></i></b-button>
                <b-button type="submit" class="col-8 m-1 pull-left service-btn" size="sm" variant="primary" :disabled="!checkauth" @click="validateForm(id)"> {{$t('COMMON.VALIDATE_UPDATE')}} </b-button>
                <b-button class="col-1 m-1 pull-left service-btn" size="sm" variant="secondary" :disabled="canGoToNext" @click="saveAndGoToPage(nextPage)"><i class="fa fa-angle-double-right" v-b-tooltip.hover title="Next Page"></i></b-button>
              </b-row>
              <b-row>
                <b-button v-if="canGoToNext" class="col-6 offset-2 mt-1 service-btn" size="sm" variant="secondary" v-b-tooltip.hover :title="$t('COMMON.SAVE')" @click="validateToExport" :disabled="!checkauth">{{$t('COMMON.SAVE')}}</b-button>
              </b-row>
            </div>
            <div slot="footer" align="center" v-else>
              <b-button type="submit" class="px-5 save-btn" size="sm" variant="primary" @click="validateForm(id)" > {{$t('COMMON.VALIDATE_UPDATE')}} </b-button>
            </div>
          </b-card>
        </b-col>
        <b-col lg="8">
          <b-card v-if="!editorDataLoaded">
            <div slot="header">
              <strong>{{$t('COMMON.FORM')}}:</strong>
            </div>
            <content-placeholders >
              <content-placeholders-img style="height: 765px"/>
              </content-placeholders>
          </b-card>
          <b-card v-else class="canvas-card mb-3" >
            <div slot="header">
              <div class="d-flex justify-content-between ">
                <div style="padding:10px">
                  <strong>{{ $t('FORMS.AVG_CONF') }} : <b-badge :variant="confidenceVariant">{{ avgConfidenceScore }}</b-badge></strong>
                </div>
                <b-row>
                  <strong class="mr-1" style="margin-top: 11px">{{ $t('FORMS.SELECT_PAGE_NUM')}} </strong>
                  <b-form-select class="page_numbers" :plain="true" style="width: 75px"
                     :options="dataPages" v-model="selectedPageNum"></b-form-select>
                </b-row>
                <div class="paginate-page">
                  <b-button v-if="this.formData.export_error" variant="danger" @click="showExportError"
                    v-b-tooltip.hover :title="$t('FORMS.EXPORT_ERROR')">
                    <i id ="exportError" class="fa fa-exclamation-triangle"></i>
                  </b-button>
                  <b-button variant="primary" @click="!toShowOriginalImage ? showOriginalImage(0) : showOriginalImage(1)"><span>{{!toShowOriginalImage ? 'Show Original Doc' : 'Revert Back' }}</span></b-button>
                  <b-button variant="primary" @click="hideUnhideScreen"><span>{{ ishideUnhideClicked ? 'Unhide' : 'Hide' }}</span></b-button>
                  <b-button variant="secondary" @click="showCompareModal">
                    <div class="compare-icon" v-html="svg.clone"></div>
                    <span>{{ $t('FORMS.COMP_IMAGES') }}</span>
                  </b-button>
                  <b-button variant="primary" size="md" v-if="formData.template_id > 0 && appMode === 'default'"
                    @click="redirectToMatchedTemplate" v-b-tooltip.hover :title="$t('FORMS.MATCHING_TEMPLATE')">
                    <i class="fa fa-file-text-o" aria-hidden="true"></i>
                  </b-button>
                  <b-button v-if="$store.state.role == 'admin'" size="md" @click="showUpdateLogs(1)">
                    <i class="fa fa-table" aria-hidden="true" v-b-tooltip.hover title="Show Update Logs"></i>
                  </b-button>
                </div>
              </div>
            </div>
            <div v-if="isAdminRole" id="canvasShow"> </div>
            <div v-else oncontextmenu="return false;" id="canvasShow"> </div>
          </b-card>
          <div class="d-flex justify-content-between">
            <b-button variant="primary" :disabled="canGoToPrev" @click="saveAndGoToPage(prevPage)" >Previous</b-button>
            <b-button variant="primary" :disabled="canGoToNext" @click="saveAndGoToPage(nextPage)" >Next</b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <b-modal title="Form Updates" size="lg" ref="formUpdateLogsTable" centered>
      <b-container fluid>
        <div v-if="this.formUpdateLogs.length && isLogsLoaded">
          <b-table bordered hover striped
            :fields="updateFields" 
            :items="formUpdateLogs" 
            :filter="filter"
            :filter-included-fields="filterOn"
          >
            <template slot="original" slot-scope="data">
              <span>
                <div v-for="item in data.value">{{item}}</div>
              </span>
            </template>
            <template slot="updated" slot-scope="data">
              <span>
                <div v-for="item in data.value">{{item}}</div>
              </span>
            </template>
          </b-table>
          <b-pagination 
            v-model="logsCurrentPage"
            :total-rows="totalUpdateLogs" 
            :per-page="logsPerPage"
            @input = "logsPagination" 
            align="center"
          >
          </b-pagination>
        </div>
        <div v-else-if="isLogsLoaded">
          No logs available
        </div>
        <div v-else>
          <content-placeholders >
            <content-placeholders-img style="height: 765px"/>
          </content-placeholders>
        </div>
      </b-container>
      <div slot="modal-footer">
        <b-btn size="sm" @click="closeUpdateLogs"> Close </b-btn>
      </div>
    </b-modal>

    <b-modal :title="$t('FORMS.AUTO_CORRECT')" ref="autoCorrectModal" :ok-title="$t('COMMON.ADD')" :cancel-title="$t('COMMON.CANCEL')" @ok="saveAutoCorrectStatus()" @cancel="dontSaveAutoCorrectStatus()" ok-variant="secondary" cancel-variant="light" no-close-on-esc
    hide-header-close centered no-close-on-backdrop>
      <b-row>
        <b-col>
          <p style="color:red;">Below selected fields data will use to auto correct for future forms </p>
        </b-col>
      </b-row>
      <b-row class="mb-3" v-if="updatedData.length > 0">
        <div style="padding: 5px" v-for="data in updatedData" :key="data.id">
          <input class="pull-left mt-1 mr-2" v-if="data.data_type == 'text' && data.present_in_dict !=true" type="checkbox" :id="data.id" ref="CheckboxClicks">
          <label class="pull-left" v-if="data.data_type == 'text' && data.present_in_dict != true" :for="data.id"> {{data.key}} </label>
        </div>
      </b-row>
    </b-modal>

    <b-modal size="xl" :title="$t('FORMS.VALIDATION_HEADER')" close-on-esc hide-header-close close-on-backdrop centered ref="fieldInvalidModal">
      <b-container fluid class="error_listing">
        <div class="mb-3 error_listing" v-if="combinedErrors.length > 0">
          <h5 class="error_listing"><strong>{{ $t('FORMS.SERVICE_VALIDATION') + ':' }}</strong></h5>
          <p class="error_listing" v-for="(error, index) in combinedErrors" :key="error['key']">
            {{ index + 1 }}. {{ error['reason'] }}
          </p>
        </div>
        <div class="mb-3 error_listing" v-if="requiredFieldsError && requiredFieldsError.length > 0">
          <h5 class="error_listing"><strong>{{ $t('FORMS.REQUIRED_FIELDS_VALIDATION') + ':' }}</strong></h5>
            <p class="error_listing" v-for="(error,index) in requiredFieldsError" :key="error['key']">
              {{index+1}}. {{error['reason']}}
            </p>
        </div>
        <div class="mb-3 error_listing" v-if="validateUpdateErrorMessages && validateUpdateErrorMessages.length > 0" >
          <h5 class="error_listing"><strong>{{ $t('FORMS.VALIDATION_ERROR') + ':' }}</strong></h5>
          <b-row class="mb-1 error_listing">
            <b-col cols="3"><strong>Field</strong></b-col>
            <b-col cols="3"><strong>Type</strong></b-col>
            <b-col cols="6"><strong>Value</strong></b-col>
          </b-row>
          <b-row class="mb-1 error_listing" v-for="message in validateUpdateErrorMessages" :key="message.pv_id">
            <b-col cols="3">{{ message.key | capitalize }} </b-col>
            <b-col cols="3">{{ message.type | capitalize }} </b-col>
            <b-col cols="6" style="word-wrap: break-word;">{{ message.current_value }}</b-col>
          </b-row>
        </div>
        <div class="mb-3 error_listing" v-if="optionalErrorMessages && optionalErrorMessages.length > 0">
          <h5 class="error_listing"><strong>{{ $t('FORMS.OPTIONAL_FIELDS_VALIDATION') + ':' }}</strong></h5>
            <p class="error_listing" v-for="(error,index) in optionalErrorMessages" :key="error['key']">
              {{index+1}}. {{error['reason']}}
            </p>
        </div>
        <!-- <b-row class="mb-1 text-center">
          <b-col cols="3"><strong>Field</strong></b-col>
          <b-col cols="3"><strong>Type</strong></b-col>
          <b-col cols="6"><strong>Value</strong></b-col>
        </b-row>
        <b-row class="mb-1 text-center" v-for="message in errorMessages" :key="message.pv_id">
          <b-col cols="3">{{ message.key | capitalize }} </b-col>
          <b-col cols="3">{{ message.type | capitalize }} </b-col>
          <b-col cols="6" style="word-wrap: break-word;">{{ message.current_value }}</b-col>
        </b-row> -->
      </b-container>
      <div slot="modal-footer">
        <b-btn size="sm" variant="secondary" @click="showSaveData"> {{ $t('COMMON.OKAY') }} </b-btn>
      </div>
    </b-modal>

    <b-modal id="newField" :title="$t('FORMS.ADD_FIELD')" ref="newFieldModal" hide-header-close centered>
      <div>
        <b-card>
          <b-row class="form-group">
            <b-col cols="6">
              <label for="name"> {{ $t('FORMS.LABEL') }} </label>
              <b-form-input id="input1" v-model="newFieldLabel"></b-form-input>
            </b-col>
            <b-col cols="6">
              <label for="name"> {{ $t('FORMS.VALUE') }} </label>
              <b-form-input id="input1" v-model="newFieldValue"></b-form-input>
            </b-col>
          </b-row>
        </b-card>
      </div>
      <div slot="modal-footer">
        <b-btn size="sm" variant="secondary" @click="addNewField"> {{ $t('COMMON.ADD') }} </b-btn>
        <b-btn size="sm" variant="light" @click="hideModal"> {{ $t('COMMON.CANCEL') }} </b-btn>
      </div>
    </b-modal>

    <b-modal title="Image Comparison"
      size="lg" class="modal-primary" hide-header-close centered hide-footer ref="compareCardsModal" @hidden="onHideCompareModal">
      <b-container fluid>
        <b-row class="mb-1 text-center">
          <b-col cols="6">
            <b-card header="Uploaded Image" class="shadow" v-if="isOpenCompareUploaded">
              <img oncontextmenu="return false;" :src="this.imgBase + this.formData.original_image_url" class="compare-image">
            </b-card>
          </b-col>
          <b-col cols="6">
            <b-card header="Enhanced Image" class="shadow" v-if="isOpenCompareUploaded">
              <img oncontextmenu="return false;" :src="this.imgBase + this.formData.image_url" class="compare-image">
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-modal :title="$t('FORMS.EXPORT_ERROR')"
      hide-header-close centered ok-only ok-variant="secondary" ref="exportErrorModal">
      <p>{{ this.formData.short_export_error }}</p>
    </b-modal>
    <b-modal title="Add Data Manually" size="md" ref="addDataModal" @ok="fetchTemplateMappings">
      <b-row>
        <b-input-group>
          <b-col class="p-1 col-4 col-sm-4">
            <label>Select Template</label>
          </b-col>
          <b-col class="p-1 col-8 col-sm-4">
              <b-form-select class="reprocess-input"
                             :plain="true"
                             :options="templateOptions"
                             v-model="selectedTemplate"
                             @input="handleSelectedTemp()"
                             :placeholder="$t('FORMS.TEMPLATE')">
              </b-form-select>
          </b-col>
          <b-col class="p-1 col-12 col-sm-4">
            <zoom-center-transition>
              <img :src="previewImageUrl" class="shadow preview-image">
            </zoom-center-transition>
          </b-col>
          <!-- <b-col v-if="selectedTemplate">
            <label> Select Page </label>
          </b-col>
          <b-col class="p-1 col-8 col-sm-4" v-if="selectedTemplate">
            <b-form-select class="reprocess-input"
                             :plain="true"
                             :options="templatePageOptions"
                             v-model="selectedTemplatePage"
                             @input="handleSelectTemplatePage()"
                             :placeholder="$t('FORMS.TEMPLATE')">
              </b-form-select>
          </b-col> -->
          <b-col class="p-1 col-12 col-sm-4">
            <zoom-center-transition>
              <img :src="pagePrevImgUrl" class="shadow preview-image">
            </zoom-center-transition>
          </b-col>
        </b-input-group>
      </b-row>
    </b-modal>
    <b-modal :title="$t('FORMS.TABLE_DATA')" size="lg" class="modal-primary" centered hide-footer ref="TableDataModal" @hidden="closeTableModal">
      <b-container fluid>
        <b-row>
          <h4 class="processedData"><strong>{{ $t('FORMS.PROCESSED_DATA') + ':' }}</strong></h4>
          <b-col lg=1 offset=9>
            <div class="save-data">
              <b-button variant="secondary" size="sm" @click="saveData(true)">
                <i class="fa fa-save"></i>&nbsp;{{ $t('COMMON.SAVE') }}
              </b-button>
            </div>
          </b-col>
        </b-row>
        <div style="height:100px; width: 100%">
          <canvas id='table-header-canvas' style='border: 1px solid; width: 100%; max-height: 50px;'>
          </canvas><br>
          <canvas id='table-row-canvas' style='border: 1px solid; width: 100%; max-height: 50px;'>
          </canvas><br>
        </div>
        <b-card style="overflow-x:auto; margin-top: 15px" v-if="selectedTablePath">
          <div class="table-model-y model-scrollbar">
            <table style="table-layout: auto;" class="stick-table">
              <thead>
                <th v-for="(header, index) in selectedTableData['children'][0]['children']" :key=index>{{ header['key'] }}</th>
              </thead>
              <tbody>
                <tr v-for="(row, index) in selectedTableData['children'].slice(1)"
                    v-on:mouseover="hoverRow(row, index)" :key=index>
                  <td v-for="(cell, index) in row['children']" :key=index>
                    <span v-if="cell.current_value !== cell.original_value">
                      <input class="table-input table-input-edited"
                              @click="highlightInRow(cell, row, index)"
                              @change="updateTableData($event, cell)"
                              :value="cell.current_value"
                              v-b-tooltip.hover.right :title="'Original Value: ' + cell.original_value "/>
                    </span>
                    <span v-else>
                      <input class="table-input"
                              @click="highlightInRow(cell, row, index)"
                              @change="updateTableData($event, cell)"
                              :value="cell.current_value"/>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-card>
      </b-container>
    </b-modal>

    <b-modal :title="isFormDocValid ? $t('COMMON.CONFIRM') : $t('FORMS.VALIDATION_HEADER')" hide-header-close centered @hidden="cancelExport" ref="errorsAcknowledgementModal" ok-variant="secondary" cancel-variant="primary" :ok-title="$t('COMMON.SAVE')" @ok="exportDataToService" @cancel="cancelExport">
      <b-container fluid>
        <div v-if="this.isFormDocValid">
          <div class="save-btn">
            Are you sure you want to save data on Salesforce?
          </div>
        </div>
        <div v-else>
          <b-row class="mb-1 text-center">
            <b-col cols="6"><strong>Page No.</strong></b-col>
            <b-col cols="6"><strong>Errors</strong></b-col>
          </b-row>
          <b-row class="mb-1 text-center" v-for="pageErrors in pageLevelErrors" :key="pageErrors.page">
            <b-col cols="6">{{ pageErrors.page }} </b-col>
            <b-col cols="6">{{ pageErrors.errors.length }} </b-col>
          </b-row>
          <b-row>
            <div class="error-acknowledgement">
              There are data errors thats needs to be fixed. Do you really want to save data on salesforce without verifiying them?
            </div>
          </b-row>
        </div>
      </b-container>
    </b-modal>

    <b-modal :title="isInvoiceVerified ? $t('INVOICE.APPROVE_SIGN') : $t('INVOICE.SIGN_INVOICE')"
              ref="signInvoiceModal" hide-header-close centered @hidden="hideSignInvoice"
              ok-variant="secondary" cancel-variant="primary"
              :ok-title="isInvoiceVerified ? $t('INVOICE.APPROVE') : $t('INVOICE.SIGN')"
              @ok="signInvoice" @cancel="hideSignInvoice">
      <b-row class="m-2">
        <b-col md="4">
          <label>{{ $t('INVOICE.ACCOUNT') }}<span class="required">*</span></label>
        </b-col>
        <b-col md="8">
          <b-form-select class="form-control" :plain="true"
                          :class="{'is-invalid': $v.invoice.selectedAccount.$error, 'is-valid': !$v.invoice.selectedAccount.$invalid}"
                          :options="invoiceSign.accounts"
                          v-model="invoice.selectedAccount">
          </b-form-select>
          <b-form-invalid-feedback v-if="!$v.invoice.selectedAccount.required">{{ $t('INVOICE.ACC_REQ') }}</b-form-invalid-feedback>
        </b-col>
      </b-row>
      <b-row class="m-2">
        <b-col md="4">
          <label>{{ $t('INVOICE.ACCOUNTING_UNIT') }}<span class="required">*</span></label>
        </b-col>
        <b-col md="8">
          <b-form-select class="md -8 form-control" :plain="true"
                          :class="{'is-invalid': $v.invoice.selectedAccountingUnit.$error, 'is-valid': !$v.invoice.selectedAccountingUnit.$invalid}"
                          :options="invoiceSign.accountingUnits"
                          v-model="invoice.selectedAccountingUnit">
          </b-form-select>
          <b-form-invalid-feedback v-if="!$v.invoice.selectedAccountingUnit.required">{{ $t('INVOICE.ACC_UNIT_REQ') }}</b-form-invalid-feedback>
        </b-col>
      </b-row>
      <b-row class="m-2">
        <b-col md="4">
          <label>{{ $t('INVOICE.TOTAL_AMOUNT') }}<span class="required">*</span></label>
        </b-col>
        <b-col md="8">
          <input  class="form-control" type="number" id="totalAmount"
                  :class="{'is-invalid': $v.invoice.totalAmount.$error, 'is-valid': !$v.invoice.totalAmount.$invalid}"
                  v-model="invoice.totalAmount" />
          <b-form-invalid-feedback v-if="!$v.invoice.totalAmount.required">{{ $t('INVOICE.AMT_REQ') }}</b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="!$v.invoice.totalAmount.minLen">{{ $t('INVOICE.MIN_AMT') }}</b-form-invalid-feedback>
        </b-col>
      </b-row>
      <b-row class="m-2">
        <b-col md="4">
          <label>{{ $t('INVOICE.NOTES') }}</label>
        </b-col>
        <b-col md="8">
          <input  class="form-control" type="text" v-model="invoice.description" />
        </b-col>
      </b-row>
    </b-modal>

    <b-modal ref="saveFieldsAlertModel" :title="$t('COMMON.ALERT')" centered header-text-variant="danger"
    ok-variant="secondary" @ok="confirmChanges()" :ok-title="$t('COMMON.SAVE')" :ok-disabled="!checkauth"
    cancel-variant="danger" @cancel="cancelNavigation(getCurrentPage)" @hidden="cancelNavigation(getCurrentPage)">
      {{ $t('COMMON.SAVE_ALERT')}}
    </b-modal>

    <b-modal ref="slaesForceAlertModal" centered title="Sales Force Validation Error" ok-variant="secondary"  ok-only>
      {{salesForeceValidationError}}
    </b-modal>
    <b-modal :title="$t('FORMS.MULTI_USER_MODAL')" ref="multipleUserAlert" hide-header-close centered>
      <strong>{{$t('FORMS.MULTI_USER_ALERT_MSG')}}</strong>
      <div slot="modal-footer">
        <b-btn size="sm" variant="secondary" @click="goBackToFormsPage"> {{ $t('COMMON.GO_BACK') }} </b-btn>
      </div>
    </b-modal>
    <b-modal hide-header-close  title="Reject Form" header-bg-variant="light" ref="rejectFormDoc" centered>
        <b-card class="mt-3">
          <b-row class="form-group">
            <b-col cols="12">
              <img src="../../../static/img/exclamation.png">
              <h5>Do you want to reject this document?</h5>
            </b-col>
          </b-row>
        </b-card>
        <div slot="modal-footer">
          <b-btn size="sm" variant="danger" @click="rejectForm"> Confirm </b-btn>
          <b-btn size="sm" variant="light" @click="hideRejectFormDocModal"> {{ $t('COMMON.CANCEL') }} </b-btn>
        </div>
      </b-modal>
</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Konva from 'konva'
import router from '../../router'
import processedDataTree from '@/components/process/processedDataTree'
import pagination from '@/components/mixins/Train/pagination'
import validators from '@/components/mixins/validators'
import { required, minValue } from 'vuelidate/lib/validators'
import moment from 'moment'
import _ from 'lodash'
import svg from '../../_svg.js'

export default {
  props: ['formId'],
  data () {
    return {
      id: this.formId || this.$route.params.id,
      imgBase: process.env.API_URL.replace('/api', ''),
      konvaStage: '',
      formData: {},
      treePath: {},
      dataBus: new Vue(),
      updatedData: [],
      checkedUpdatedData: [],
      spareFormData: {},
      baseLayer: null,
      scrollHeight: 10000,
      editorDataLoaded: false,
      serviceValidationErrorMessage: [],
      requiredFieldsValidationError: [],
      isSignatureValidated: null,
      isServiceValidated: null,
      formValidations: null,
      processedDataLoaded: false,
      newFieldLabel: null,
      newFieldValue: null,
      svg: svg,
      showMessage: false,
      isFormDocValid: true,
      pageLevelErrors: [],
      minConf: 0,
      maxConf: 100,
      formUpdateLogs: [],
      isLogsLoaded: false,
      updateFields: [
        {key: 'index', label: 'Version'},
        {key: 'updated_by', label: 'Updated By'},
        {key: 'field', label: 'Field'},
        {key: 'original', label: 'Original Text'},
        {key: 'updated', label: 'Updated Text'},
        {key: 'updated_at', label: 'Updated Date & Time'}
      ],
      filterOn: ['field'],
      filter: null,
      updateLogsFilterOptions: [
        {value: null, text: 'all'},
        {value: 'Gender', text: 'Gender'},
        {value: 'Phone', text: 'Phone'},
        {value: 'Name', text: 'Name'}
      ],
      logsCurrentPage: 1,
      showAddDataButton: true,
      logsPerPage: 5,
      totalUpdateLogs: 0,
      tableHeaders: [],
      originalPEVs: {},
      updatedPEVs: {},
      dataPages: [{ text: 'Select Page Number', value: null }],
      selectedPageNum: 0,
      showInsClaim: false,
      verification_start: false,
      updatedPEVIds: [],
      invoice: {
        selectedAccount: null,
        selectedAccountingUnit: null,
        totalAmount: null,
        description: ''
      },
      invoiceSign: {
        accounts: [],
        accountingUnits: []
      },
      selectedTablePath: null,
      currentHoverIndex: null,
      prev_form_id: null,
      next_form_id: null,
      navigatingPage: 0,
      templateOptions: [],
      selectedTemplate: null,
      previewImageUrl: '',
      templatePageOptions: [],
      selectedTemplatePage: null,
      pagePrevImgUrl: '',
      autoCorrectFlag2: false,
      autoCorrectFlag1: false,
      editOnly: false,
      salesForeceValidationError: null,
      processValueText: '',
      dataPresent: true,
      isOpenCompareUploaded: false,
      image_url: '',
      original_image_url: '',
      toShowOriginalImage: false,
      ishideUnhideClicked: false
    }
  },
  created () {
    // Toggle sidebar for this page
    // TODO: Move to a common place. Remove duplicates
    window.addEventListener('scroll', this.handleScroll)

    let classList = document.body.classList
    if (!classList.contains('sidebar-minimized')) {
      classList.toggle('sidebar-minimized')
      classList.toggle('brand-minimized')
    }

    let vm = this
    this.dataBus.$on('updateData', (value) => {
      let updateIds = value.map((val) => { return val.id })
      let uniqUpdateData = vm.updatedData.filter((item) => {
        return updateIds.indexOf(item.id) === -1
      })
      vm.updatedData = uniqUpdateData
      value.forEach((val) => { vm.updatedData.push(val) })
    })
    this.dataBus.$on('setFocus', (path) => {
      vm.highlightText(path)
    })
    this.dataBus.$on('deleteData', (pvId) => {
      vm.deleteFormData(pvId)
    })
    this.dataBus.$on('enableResize', (path) => {
      vm.enableTransformer(path)
    })
    this.dataBus.$on('saveResize', (data) => {
      vm.updateResize(data)
    })
    this.dataBus.$on('resetResize', () => {
      vm.resetTransformersAndShapes()
    })
    this.dataBus.$on('showTable', (path) => {
      this.selectedTablePath = path
      this.displayHeader(this.selectedTableData['children'][0])
      this.hoverRow(this.selectedTableData['children'][1], 0)
      this.$refs.TableDataModal.show()
    })
    return this.fetchForm()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  components: {
    'processed-data-tree': processedDataTree
  },
  computed: {
    ...mapGetters([ 'idToken', 'userRole', 'userRoleOrder', 'selectedRolesData', 'appMode', 'isAdminRole' ]),
    combinedErrors () {
      return [...this.serviceValidationError]
    },
    processData: function () {
      if (this.formData.processed_tree_data) {
        return this.formData.processed_tree_data
      } else {
        return []
      }
    },
    docId: function () {
      return this.formData.form_doc_id
    },
    currentFormId: function () {
      return this.formData.id
    },
    formStatus: function () {
      return this.formData.form_status
    },
    docStatus: function () {
      return this.formData.form_doc_status
    },
    checkauth: function () {
      var status = 'stage_' + this.userRoleOrder
      return this.appMode === 'default' ? this.docStatus === 'unmatched' || (this.docStatus === status && (this.formData.template_id === '-6' || this.formData.template_id === '-15' || this.formData.template_id === '-16' || this.formData.template_id === '-17' || this.formData.template_id === '-18' || this.formData.template_id === '-2' || this.formStatus === status)) : true
    },
    processDone: function () {
      return (parseInt(this.userRoleOrder) >= this.selectedRolesData.length) ? this.$t('FORMS.ACCEPT') : this.$t('FORMS.VERIFY')
    },
    avgConfidenceScore: function () {
      var confidences = []
      var confidencesForEachForm = []
      this.processData.forEach(eachParent => {
        if (eachParent) {
          confidencesForEachForm = this.getConfidenceScores([], eachParent)
        }
        confidences.push(...confidencesForEachForm)
      })
      var totalConfidence = 0
      for (var i = 0; i < confidences.length; i++) {
        totalConfidence += confidences[i] * 100
      }
      return (confidences.length > 0) ? Math.round(totalConfidence / confidences.length) : 0
    },
    confidenceVariant: function () {
      if (this.avgConfidenceScore <= 40) {
        return 'danger'
      } else if (this.avgConfidenceScore <= 70 && this.avgConfidenceScore > 40) {
        return 'warning'
      } else if (this.avgConfidenceScore <= 90 && this.avgConfidenceScore > 70) {
        return 'secondary'
      } else {
        return 'success'
      }
    },
    shouldShowSignInvoice: function () {
      return ((parseInt(this.formData.template_id) === -6) && (parseInt(this.formData.template_id === -16)) &&
                (parseInt(this.formData.template_id === -17)) &&
                (this.formData.form_doc_status === 'stage_1') &&
                (!this.isInvoiceVerified))
    },
    shouldShowApproveInvoice: function () {
      return ((parseInt(this.formData.template_id) === -6) && (parseInt(this.formData.template_id === -16)) &&
                (parseInt(this.formData.template_id === -17)) &&
                (this.userRoleOrder > 1) &&
                (!this.isInvoiceApproved) &&
                (this.formData.form_doc_status !== 'accepted'))
    },
    isInvoiceVerified: function () {
      let signDetails = this.formData.sign_details
      return signDetails && !!signDetails.verification_details
    },
    isInvoiceApproved: function () {
      let signDetails = this.formData.sign_details
      return signDetails && !!signDetails.approval_details
    },
    selectedTableData: function () {
      return this.formData.processed_tree_data[0].children.filter((child) => {
        return child.path === this.selectedTablePath && child.map_type !== 'shape'
      })[0]
    },
    hideExpandCollapse: function () {
      let hasSection = false
      this.formData.processed_tree_data.forEach((pageData) => {
        if (pageData && pageData.children) {
          pageData.children.forEach((children) => {
            if (children.data_type === 'section') {
              hasSection = true
            }
          })
        }
      })
      return hasSection
    }
  },
  watch: {
    processData: {
      handler: async function () {
        let treePath = {}
        this.processData.forEach(processDataForEachForm => {
          if (processDataForEachForm) {
            treePath = this.fetchTreePath(processDataForEachForm, treePath)
          }
        })
        this.treePath = treePath
        await this.getImageUrls(true)
          .then(response => {
            this.createCanvas()
          })
      }
    },
    '$route': function () {
      this.id = this.$route.params.id
      this.fetchForm()
    },
    selectedPageNum: function () {
      if (this.selectedPageNum !== this.getCurrentPage - 1) {
        this.saveAndGoToPage(this.selectedPageNum)
      }
    },
    processValueText: function () {
      let checkMatchSection = false
      let checkDataPresent = false
      this.formData.processed_tree_data.forEach(sectionData => {
        if (sectionData && sectionData.children) {
          sectionData.children.forEach(children => {
            if (children.data_type === 'section') {
              children.children.forEach(child => {
                if (child.data_type === 'name') {
                  child.children.forEach(innerchild => {
                    if ((innerchild.key.toLowerCase()).includes(this.processValueText.toLowerCase())) {
                      innerchild.show_field = true
                      checkMatchSection = true
                    } else {
                      innerchild.show_field = false
                    }
                  })
                } else {
                  if ((child.key.toLowerCase()).includes(this.processValueText.toLowerCase())) {
                    child.show_field = true
                    checkMatchSection = true
                  } else {
                    child.show_field = false
                  }
                }
              })
              if (checkMatchSection) {
                children.show_section = true
                checkDataPresent = true
              } else {
                children.show_section = false
              }
            } else {
              if (children.data_type === 'name') {
                children.children.forEach(innerchild => {
                  if ((innerchild.key.toLowerCase()).includes(this.processValueText.toLowerCase())) {
                    innerchild.show_field = true
                    checkDataPresent = true
                  } else {
                    innerchild.show_field = false
                  }
                })
              } else if ((children.key.toLowerCase()).includes(this.processValueText.toLowerCase())) {
                children.show_field = true
                checkDataPresent = true
              } else {
                children.show_field = false
              }
            }
            checkMatchSection = false
          })
        }
      })
      this.dataPresent = checkDataPresent
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('DD MMMM YYYY HH:mm:ss')
    }
  },
  mixins: [ pagination, validators ],
  methods: {
    expandAllSections () {
      this.formData.processed_tree_data.forEach(data => {
        if (data && data.children) {
          data.children.forEach(child => {
            if (child.data_type === 'section') {
              child.show_section = true
            }
          })
        }
      })
    },
    collapseAllSections () {
      this.formData.processed_tree_data.forEach(data => {
        if (data && data.children) {
          data.children.forEach(child => {
            if (child.data_type === 'section') {
              child.show_section = false
            }
          })
        }
      })
    },
    showRejectFormModal () {
      this.$refs.rejectFormDoc.show()
    },
    hideRejectFormDocModal () {
      this.$refs.rejectFormDoc.hide()
    },
    handleScroll: function () {
      this.$root.$emit('bv::hide::popover')
    },
    rejectForm: function () {
      let payload = {
        formDocId: this.formData.form_doc_id
      }
      Vue.axios.post('form_docs/reject_form_docs', payload, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.hideRejectFormDocModal()
          this.$router.push('/process/processed')
          Vue.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' })
          Vue.toasted.show(`Form will remain in the system for ${res.data.retention_time} hours`, { icon: 'chain-broken', type: 'success' })
        })
        .catch(err => {
          console.log(err)
        })
    },
    hoverRow: function (row, index) {
      if (index !== this.currentHoverIndex) {
        this.displayRow(row.x_pos, row.y_pos, row.width, row.height)
        this.currentHoverIndex = index
      }
    },

    logsPagination (selectedPage) {
      this.showUpdateLogs(selectedPage)
    },
    getChildren (children, key) {
      let result = []
      children.forEach((child) => {
        if (child[key] === 'true') {
          result.push(child.key)
        }
      })
      return result
    },
    generateLogVersions (logsCount, pageNumber) {
      let logsPerPage = this.logsPerPage
      let startVersion = logsCount - logsPerPage * (pageNumber - 1)
      return Array(logsPerPage).fill().map((element, index) => startVersion - index)
    },
    showUpdateLogs (pageNumber) {
      this.$refs['formUpdateLogsTable'].show()
      Vue.axios.get('/form_update_logs/fetchUpdatesPagination', { headers: { Authorization: `Bearer ${this.idToken}` }, params: {form_doc_id: this.docId, form_id: this.id, page: pageNumber, size: this.logsPerPage} })
        .then(response => {
          let versions = this.generateLogVersions(response.data.count, pageNumber)
          this.totalUpdateLogs = response.data.count
          this.logsCurrentPage = pageNumber
          let logs = response.data.updates
          let tableData = []
          this.isLogsLoaded = true
          let updateLogsFiltersMap = {}
          logs.forEach((log, logIndex) => {
            log.updates_data.forEach((update) => {
              if (!update.children) {
                tableData.push({
                  index: versions[logIndex],
                  updated_by: log.updated_by,
                  field: update.key,
                  original: [ update.value_before ],
                  updated: [ update.value_after ],
                  updated_at: moment(log.created_at).format('MM/DD/YYYY, h:mmA')
                })
              } else {
                tableData.push({
                  index: logs.length - logIndex,
                  updated_by: log.updated_by,
                  field: update.key,
                  original: this.getChildren(update.children, 'value_before'),
                  updated: this.getChildren(update.children, 'value_after'),
                  updated_at: moment(log.created_at).format('MM/DD/YYYY, h:mmA')
                })
              }
              updateLogsFiltersMap[update.key] = true
            })
            if (logIndex !== logs.length - 1) {
              tableData.push({
                index: '',
                updated_by: '',
                field: '',
                original: [ ],
                updated: [ ],
                updated_at: ''
              })
            }
          })
          let updateLogsFilterOptions = Object.keys(updateLogsFiltersMap).map((key) => {
            return {
              value: key,
              text: key
            }
          })
          updateLogsFilterOptions.push({value: null, text: 'all'})
          this.updateLogsFilterOptions = updateLogsFilterOptions
          this.formUpdateLogs = tableData
        })
        .catch(_error => {
          this.closeUpdateLogs()
          Vue.toasted.show('faild fetching form update logs', { icon: 'chain-broken', type: 'error' })
        })
    },
    closeUpdateLogs () {
      this.formUpdateLogs = []
      this.$refs['formUpdateLogsTable'].hide()
    },

    displayRow: function (Xpos, Ypos, width, height, callback) {
      var canvas = document.getElementById('table-row-canvas')
      canvas.width = width
      canvas.height = height
      var ctx = canvas.getContext('2d')
      var image = new window.Image()
      image.src = this.imgBase + this.formData.image_url
      image.onload = function () {
        ctx.drawImage(image, Xpos, Ypos, width, height, 0, 0, width, height)
        if (callback) {
          callback()
        }
      }
    },

    confirmChanges: function () {
      this.$refs.saveFieldsAlertModel.hide()
      this.saveData(true)
      this.goToPage(this.navigatingPage)
    },

    async saveAndGoToPage (newPage) {
      this.selectedPageNum = newPage
      this.id = this.getcurrentDocId(newPage)
      this.editorDataLoaded = false
      this.goToPage(newPage)
      this.setPagination('process/forms')
      this.editorDataLoaded = true
      await this.getImageUrls(true)
        .then(response => {
          this.createCanvas()
        })
    },

    cancelNavigation (currentPage) {
      this.updatedData = []
      this.selectedPageNum = currentPage - 1
      this.goToPage(this.navigatingPage)
    },

    downloadEligibility: function () {
      this.verification_start = true
      this.$refs.verification_spin.innerText = this.$t('FORMS.CHECKING_ELIG_BTN_LABEL')
      Vue.axios.post('/forms/check_eligibility', {form_doc_id: this.formData.form_doc_id}, { headers: { Authorization: `Bearer ${this.idToken}` }, responseType: 'blob' })
        .then(res => {
          this.verification_start = false
          this.$refs.verification_spin.innerText = this.$t('FORMS.CHECK_ELIG_BTN_LABEL')
          this.showMessage = true
        })
        .catch(err => console.log(err))
    },

    displayHeader: function (BoundingBox) {
      var canvas = document.getElementById('table-header-canvas')
      canvas.width = BoundingBox.width
      canvas.height = BoundingBox.height
      var ctx = canvas.getContext('2d')
      var image = new window.Image()
      image.src = this.imgBase + this.formData.image_url
      image.onload = function () {
        ctx.drawImage(image, BoundingBox.x_pos, BoundingBox.y_pos, BoundingBox.width, BoundingBox.height, 0, 0, BoundingBox.width, BoundingBox.height)
      }
    },

    highlightInRow: function (cell, row, index) {
      this.displayRow(row.x_pos, row.y_pos, row.width, row.height, function () {
        var diff = cell.x_pos - row.x_pos
        var canvas = document.getElementById('table-row-canvas')
        var context = canvas.getContext('2d')
        context.beginPath()
        context.globalAlpha = 0.5
        context.rect(diff, 0, cell.width, cell.height)
        context.fillStyle = '#FFFF00'
        context.fill()
        context.stroke()
      })
    },

    closeTableModal: function () {
      this.selectedTablePath = null
      this.currentHoverIndex = null
      this.$refs.TableDataModal.hide()
    },

    getConfidenceScores: function (scores, parent) {
      if (parent.children) {
        parent.children.forEach(child => {
          scores = this.getConfidenceScores(scores, child)
        })
      } else if (parent.edited && parent.is_system_generated) {
        return scores
      } else if (parent.edited) {
        scores.push(1)
      } else if (parent.current_value == null || parent.current_value.length < 1) {
        return scores
      } else if (parent.data_type === 'checkbox') {
        return scores
      } else if (parent.confidence) {
        scores.push(parent.confidence)
      }
      return scores
    },

    createCanvas: function () {
      var vm = this
      var imgObj = new window.Image()
      imgObj.crossOrigin = 'Anonymous'
      imgObj.src = this.toShowOriginalImage ? this.imgBase + this.formData.original_image_url : this.imgBase + this.formData.image_url

      imgObj.onload = function () {
        var stage = new Konva.Stage({
          container: 'canvasShow',
          width: imgObj.width,
          height: imgObj.height
        })

        vm.baseLayer = new Konva.Layer({ })
        var baseImg = new Konva.Image({
          image: imgObj,
          width: stage.width(),
          height: stage.height()
        })

        vm.baseLayer.add(baseImg)
        if (vm.processData[vm.selectedPageNum]) {
          vm.buildMapTree(vm.processData[vm.selectedPageNum], vm.processData[vm.selectedPageNum].children)
        }
        stage.add(vm.baseLayer)
        stage.draw()

        var container = document.getElementById('canvasShow')
        var scaleScore = (container.offsetWidth) / stage.width()
        vm.fillScore = stage.width() / container.offsetWidth

        stage.width(stage.width() * scaleScore)
        stage.height(stage.height() * scaleScore)
        stage.scale({ x: scaleScore, y: scaleScore })
        stage.draw()

        vm.scaleScore = scaleScore
        vm.konvaStage = stage
        vm.updateScrollHeight()
        vm.addCropLayer()
      }
    },

    updateScrollHeight: function () {
      let imageHeight = document.getElementById('canvasShow').offsetHeight
      let footerHeight = document.querySelector('.process-data > .card-footer').offsetHeight
      this.scrollHeight = imageHeight - footerHeight - 50
    },

    addCropLayer () {
      let vm = this

      const cropImg = new window.Image()
      cropImg.src = vm.baseLayer.toDataURL()
      cropImg.onload = () => {
        vm.cropLayer = new Konva.Layer({ })
        vm.cropWindow = new Konva.Rect({
          fillPatternImage: cropImg,
          fillPatternScale: {
            x: vm.fillScore,
            y: vm.fillScore
          }
        })
        vm.konvaStage.add(vm.cropLayer)
        vm.cropLayer.add(vm.cropWindow)
        vm.cropWindow.hide()
        vm.konvaStage.draw()
      }
    },
    /** For more visibility, we add padding to the bounding box **/
    buildMapTree: function (parent, children) {
      let vm = this
      let startIndexPadding = 10
      let dimensionPadding = 15
      if (children) {
        children.forEach((child) => {
          if (child.map_type === 'group') {
            let group = new Konva.Rect({
              id: child.path,
              x: child.x_pos - startIndexPadding,
              y: child.y_pos - startIndexPadding,
              width: child.width + dimensionPadding,
              height: child.height + dimensionPadding
            })
            vm.baseLayer.add(group)

            vm.buildMapTree(child, child.children)
          } else {
            let shape = new Konva.Rect({
              id: child.path,
              x: child.x_pos - startIndexPadding,
              y: child.y_pos - startIndexPadding,
              width: Number(child.width) + dimensionPadding,
              height: Number(child.height) + dimensionPadding
            })
            vm.baseLayer.add(shape)
          }
        })
      }
    },

    highlightText (path) {
      if (!this.toShowOriginalImage) {
        this.resetTransformersAndShapes()
        let nodePaths = this.treePath[path].slice()
        nodePaths.forEach((nodePath, index) => {
          let shape = this.baseLayer.findOne('#' + nodePath)
          if (shape) {
            shape.setAttrs({
              name: 'selected',
              stroke: 1,
              fill: (index > 0) ? '#63c2de' : '#FFFF00',
              opacity: 0.5
            })
          }
        })
        this.baseLayer.draw()
      }
    },

    enableTransformer (path) {
      this.resetTransformersAndShapes()
      let shape = this.baseLayer.findOne('#' + path)
      shape.setAttrs({
        name: 'selected',
        fill: '#FFFF00',
        opacity: 0.5
      })
      let transformer = new Konva.Transformer({
        rotateEnabled: false,
        keepRatio: false
      })
      this.baseLayer.add(transformer)
      transformer.attachTo(shape)
      this.baseLayer.draw()
    },

    resetTransformersAndShapes (resetFill = 'white') {
      this.buildMapTree(this.processData, this.processData.children)

      this.baseLayer.find('Transformer').destroy()
      let shapes = this.baseLayer.find('.selected')
      shapes.each(function (shape) {
        let currentFill = shape.attrs.fill
        if (currentFill === '#FFFF00' || currentFill === '#63c2de' || currentFill === resetFill) {
          shape.setAttrs({
            name: '',
            fill: 'white',
            opacity: 0
          })
        }
      })
      this.baseLayer.draw()
    },

    updateResize (data) {
      let selected = this.konvaStage.findOne('#' + data.path)
      this.cropWindow.setAttrs({
        width: selected.width() * selected.scaleX(),
        height: selected.height() * selected.scaleY(),
        fillPatternOffset: {
          x: selected.x() * this.scaleScore,
          y: selected.y() * this.scaleScore
        }
      })
      this.cropWindow.show()
      data.current_img_enc = this.cropWindow.toDataURL().replace('data:image/png;base64,', '')
      this.cropWindow.hide()
      data.x_pos = selected.x()
      data.y_pos = selected.y()
      data.width = selected.width() * selected.scaleX()
      data.height = selected.height() * selected.scaleY()

      this.cropLayer.draw()
      this.resetTransformersAndShapes()
      this.updateChunks(data)
    },

    slider: function () {
      this.minConf = Math.min(this.minConf, this.maxConf)
      this.maxConf = Math.max(this.minConf, this.maxConf)
    },

    fetchTreePath: function (node, treePath = {}) {
      treePath[node['path']] = [node['path']]
      if (node.children) {
        node.children.forEach(child => {
          treePath[node['path']].push(child['path'])
          this.fetchTreePath(child, treePath)
        })
      }
      return treePath
    },
    goBackToFormsPage () {
      router.push('/process/processed')
    },
    getImageUrls: function (a) {
      return new Promise((resolve, reject) => {
        Vue.axios.get('/forms/get_image_urls', { headers: { Authorization: `Bearer ${this.idToken}` }, params: {id: this.id} })
          .then(response => {
            if (a === true) {
              this.formData.original_image_url = response.data.original_image_url
              this.formData.image_url = response.data.image_url
              this.formData.template_id = response.data.template_id
              this.formData.revision_id = response.data.revision_id
            }
            resolve(true)
          })
          .catch(error => {
            if (error.status === 401) {
              return this.appMode === 'default' ? router.replace('/sign_in') : ''
            }
          })
      })
    },

    sortChildrenByOrder (children) {
      const valuesWithOrder = children.filter(val => val.order !== null).sort((a, b) => a.order - b.order)
      const valuesWithOutOrder = children.filter(val => val.order === null)
      return valuesWithOrder.concat(valuesWithOutOrder)
    },

    sortProcessedTreeData (data) {
      data.children = this.sortChildrenByOrder(data.children)
      data.children.forEach((child) => {
        if (child.children) {
          this.sortProcessedTreeData(child)
        }
      })
    },

    fetchForm: function () {
      this.editorDataLoaded = false
      this.processedDataLoaded = false
      // this.getImageUrls()
      Vue.axios.get('/forms/' + this.id, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          if (response.data.message) {
            this.$refs.multipleUserAlert.show()
          } else {
            let formData = response.data.form
            let treePath = {}
            let isMatched = formData.is_matched
            this.isLogsLoaded = false
            let scrollableContent = document.getElementsByClassName('scrollable-content')
            if (scrollableContent.length > 0) { scrollableContent[0].scrollTop = 0 }
            if (response.data.form.template_id === '-7') {
              this.tableHeaders = formData['processed_tree_data']['headers']
              this.originalPEVs = JSON.parse(formData['processed_tree_data']['original_entries'])
              this.updatedPEVs = JSON.parse(formData['processed_tree_data']['updated_entries'])
            }
            this.formData = formData
            this.showAddDataButton = formData.enable_add_data
            this.formData.short_export_error = this.formData.export_error ? this.formData.export_error.split(',')[1] : ''
            console.log('Salesforce Export Error: ', this.formData.export_error)
            this.dataPages = this.getDataPages(formData)
            this.allPageIdMap = response.data.form.all_processed_form_ids
            formData.processed_tree_data.forEach(element => {
              if (element) {
                treePath = isMatched ? this.fetchTreePath(element, treePath) : null
                this.sortProcessedTreeData(element)
              }
            })
            this.spareFormData = JSON.parse(JSON.stringify(formData))
            this.treePath = treePath
            this.setPagination('process/forms')
            this.editorDataLoaded = true
            this.processedDataLoaded = true
            this.next_form_id = parseInt(formData.next_form)
            this.prev_form_id = parseInt(formData.prev_form)
            if (formData.template_id === '-6' || formData.template_id === '-16' || formData.template_id === '-17') { this.fetchInvoiceSignDetails() }
            formData.processed_tree_data.children.map(data => { if (data.data_type === 'npi') { this.showInsClaim = true } })
          }
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            return this.appMode === 'default' ? console.log(this.$t('COMMON.MSG_EXPIRED')) : ''
          }
        })
    },

    getDataPages: function (formData) {
      if (formData.template_id === '-8' || formData.template_id === '-9' || formData.template_id === '-10') {
        return formData.pages_with_data.map(function (pageNum) {
          return { text: pageNum + 1, value: pageNum }
        })
      } else {
        return Object.values(formData.all_processed_form_ids).map(index => {
          return { text: index + 1, value: index }
        })
      }
    },

    fetchInvoiceSignDetails () {
      Vue.axios.get('/form_docs/invoice_sign_details', { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.invoiceSign.accounts = [{ 'text': 'Select Account', value: null }].concat(res.data.accounts)
          this.invoiceSign.accountingUnits = [{ 'text': 'Select Accounting Unit', value: null }].concat(res.data.accounting_units)
        })
        .catch(error => {
          console.log(error)
        })
    },

    showSaveData: function () {
      if (this.isSignatureValidated && this.formValidations) {
        this.updateFormStatus()
      } else if (this.isSignatureValidated === false) {
        Vue.toasted.show(this.$t('FORMS.VALIDATE_SIGNATURE'), { icon: 'chain-broken', type: 'error' })
      }
      this.saveData(this.resParams)
    },

    saveData: function (isValid) {
      let pvIDs = []
      // let count = 0
      let formData = new window.FormData()
      if (this.formData.template_id === '-7') {
        let updatedPEVs = {}
        this.updatedPEVIds.forEach(pevId => {
          updatedPEVs[pevId] = this.updatedPEVs[pevId]
        })
        formData.append('formData', JSON.stringify(updatedPEVs))
      } else {
        formData.append('formData', JSON.stringify(this.updatedData))
      }
      this.processedDataLoaded = false
      // this.editorDataLoaded = false
      this.updatedData.map(element => {
        pvIDs.push(element.id)
      })
      var data = { records: this.formData.processed_tree_data }
      var filteredProcessedTreeData = data.records.filter(function (itm) {
        return pvIDs.indexOf(itm.pv_id) > -1
      })

      for (var i = 0; i < filteredProcessedTreeData.length; i++) {
        for (var j = 0; j < this.updatedData.length; j++) {
          if (filteredProcessedTreeData[i].pv_id === this.updatedData[j].id) {
            this.updatedData[j].data_type = filteredProcessedTreeData[i].data_type
            this.updatedData[j].template_mapping_id = filteredProcessedTreeData[i].tm_id
          }
        }
        if (filteredProcessedTreeData[i].data_type === 'text') {
          this.autoCorrectFlag1 = true
        }
      }

      // check if the value is already present in dataset
      if (this.formData.auto_correct && this.formData.auto_correct.length > 0) {
        for (i = 0; i < this.updatedData.length; i++) { // 25360 25348
          for (j = 0; j < this.formData.auto_correct.length; j++) { // 25360,25348
            if (this.updatedData[i].template_mapping_id === this.formData.auto_correct[j].template_mapping_id) {
              this.updatedData[i].present_in_dict = true
              break
            } else {
              this.updatedData[i].present_in_dict = false
            }
          }
          if (this.updatedData[i].present_in_dict === false && this.updatedData[i].data_type === 'text') {
            this.autoCorrectFlag2 = true
          }
        }
      } else {
        this.autoCorrectFlag2 = true
      }
      if (this.autoCorrectFlag2 && this.autoCorrectFlag1 && this.formData.template_auto_correct_flag) {
        this.$refs.fieldInvalidModal.hide()
        this.$refs.autoCorrectModal.show()
      } else {
        this.$refs.fieldInvalidModal.hide()
        this.editOnly = true
        this.saveAutoCorrectStatus()
      }
      window.scrollTo(0, 0)
    },

    saveAutoCorrectStatus: function () {
      let payload = {}
      if (!this.editOnly) {
        let checkedIdArray = []
        this.$refs.CheckboxClicks.map(element => {
          if (element.checked === true) {
            checkedIdArray.push(element.id)
          }
        })
        for (var i = 0; i < this.updatedData.length; i++) {
          if (checkedIdArray.includes(String(this.updatedData[i].id))) {
            this.checkedUpdatedData.push({id: this.updatedData[i].id, key: this.updatedData[i].key, new_record: this.updatedData[i].new_record, form_id: this.updatedData[i].form_id, current_value: this.updatedData[i].current_value, edit_status: true})
          } else {
            if (this.updatedData[i].data_type === 'text') {
              this.checkedUpdatedData.push({id: this.updatedData[i].id, key: this.updatedData[i].key, new_record: this.updatedData[i].new_record, form_id: this.updatedData[i].form_id, current_value: this.updatedData[i].current_value, edit_status: false})
            }
          }
        }
        payload = {
          updatedData: this.updatedData,
          checkedUpdatedData: this.checkedUpdatedData
        }
      } else {
        this.editOnly = false
        payload = {
          updatedData: this.updatedData,
          checkedUpdatedData: []
        }
      }
      Vue.axios.patch('/forms/' + this.id, payload, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          Vue.toasted.show(response.data.status, { type: response.data.error ? 'error' : 'success' })
          if (this.exportFormFlag) {
            this.updateFormDocStatus()
          }
          this.updatedData = []
          this.checkedUpdatedData = []
          this.updatedPEVIds = []
          this.processedDataLoaded = true
          this.editorDataLoaded = true
          this.autoCorrectFlag2 = false
          this.autoCorrectFlag1 = false
          // window.location.reload()
          // this is temporary fix, canavas is not rendering after update
          // if (document.getElementById('canvasShow')) { this.createCanvas() }
        })
        .catch(error => {
          console.log(error)
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
          this.processedDataLoaded = true
          this.editorDataLoaded = true
          if (document.getElementById('canvasShow')) { this.createCanvas() }
        })
    },
    dontSaveAutoCorrectStatus: function () {
      this.$refs.autoCorrectModal.hide()
      this.editOnly = true
      this.saveAutoCorrectStatus()
    },
    validateToExport: function () {
      this.processedDataLoaded = false
      Vue.axios.post('/form_docs/' + this.formData.form_doc_id + '/validate', {}, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.processedDataLoaded = true
          this.isFormDocValid = res.data.valid
          this.pageLevelErrors = res.data.errors.slice(0, 10)
          this.$refs.errorsAcknowledgementModal.show()
        })
        .catch(error => {
          console.log(error)
          Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
        })
    },

    cancelExport: function () {
      this.isFormDocValid = true
      this.pageLevelErrors = []
      this.processedDataLoaded = true
      this.$refs.errorsAcknowledgementModal.hide()
    },

    exportDataToService: function () {
      this.processedDataLoaded = false
      window.scrollTo(0, 0)
      Vue.axios.post('/service/process_forms/' + this.id + '/export', {}, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.processedDataLoaded = true
          this.isFormDocValid = true
          this.pageLevelErrors = []
          this.$refs.errorsAcknowledgementModal.hide()
          if (res.data.status === 'success') {
            Vue.toasted.show(res.data.msg)
          } else {
            Vue.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' })
          }
          this.updatedData = []
          this.processedDataLoaded = true
        })
        .catch(error => {
          console.log(error)
          Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
        })
    },

    updateChunks (data) {
      let updateData = new window.FormData()
      updateData.append('x_pos', data.x_pos)
      updateData.append('y_pos', data.y_pos)
      updateData.append('width', data.width)
      updateData.append('height', data.height)
      updateData.append('current_img', data.current_img_enc)
      this.processedDataLoaded = false
      Vue.axios.patch('/form_chunks/' + data.chunk_id, updateData, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          Vue.toasted.show(this.$t('FORMS.MSG_SUCESS'))
          this.processedDataLoaded = true
        }, error => {
          if (error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'))
          }
          this.processedDataLoaded = true
        })
    },

    filterData (data, param, value) {
      let vm = this
      let filteredData = _.map(data.children, function (child) {
        if (child.hasOwnProperty('children')) {
          vm.filterData(child, param, value)
          return child
        } else if (child[param] !== value) {
          return child
        }
      })
      _.set(data, 'children', _.compact(filteredData, null))
    },

    deleteFormData (pvId) {
      this.processedDataLoaded = false
      Vue.axios.delete('processed_values/' + pvId, {headers: {Authorization: `Bearer ${this.idToken}`}})
        .then(response => {
          this.filterData(this.processData, 'pv_id', pvId)
          Vue.toasted.show(this.$t('FORMS.MSG_DEL'))
          this.processedDataLoaded = true
        }, error => {
          if (error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'))
          }
          this.processedDataLoaded = true
        })
    },

    showSignInvoice: function () {
      if (this.isInvoiceApproved) {
        let approvalDetails = this.formData.sign_details.approval_details
        this.invoice.selectedAccount = approvalDetails.account
        this.invoice.selectedAccountingUnit = approvalDetails.accounting_unit
        this.invoice.totalAmount = approvalDetails.amount
      } else if (this.isInvoiceVerified) {
        let verificationDetails = this.formData.sign_details.verification_details
        this.invoice.selectedAccount = verificationDetails.account
        this.invoice.selectedAccountingUnit = verificationDetails.accounting_unit
        this.invoice.totalAmount = verificationDetails.amount
      }
      this.$refs.signInvoiceModal.show()
    },

    hideSignInvoice: function () {
      this.$refs.signInvoiceModal.hide()
      this.$v.invoice.$reset()
      this.invoice = { selectedAccount: null, selectedAccountingUnit: null, totalAmount: null, description: '' }
    },

    signInvoice: function (event) {
      event.preventDefault()
      this.$v.$touch()
      if (!this.$v.invoice.$invalid) {
        this.editorDataLoaded = false
        this.processedDataLoaded = false
        let signDetails = new window.FormData()
        let signUrl = (
          this.isInvoiceVerified
            ? '/form_docs/' + this.docId + '/approve_sign'
            : '/form_docs/' + this.docId + '/sign_invoice'
        )
        signDetails.append('account', this.invoice.selectedAccount)
        signDetails.append('accounting_unit', this.invoice.selectedAccountingUnit)
        signDetails.append('amount', this.invoice.totalAmount)
        signDetails.append('description', this.invoice.description)
        signDetails.append('date', moment().format('DD-MM-YYYY').toString())
        Vue.axios.post(signUrl, signDetails, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(res => {
            if (res.data.success) {
              this.hideSignInvoice()
              Vue.toasted.show(this.isInvoiceVerified ? this.$t('INVOICE.APPROVAL_SUCCESSFUL') : this.$t('INVOICE.SIGN_SUCCESSFUL'))
              if (parseInt(this.id) === res.data.first_form_id) {
                this.formData.image_url = res.data.image_url
                this.formData.original_image_url = res.data.image_url
                this.formData.sign_details = res.data.sign_details
                this.processedDataLoaded = true
                this.editorDataLoaded = true
                this.createCanvas()
              } else {
                this.goToPage(0)
              }
            } else {
              Vue.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' })
            }
          }).catch(error => {
            console.log(error)
            if (error.response.status === 401) {
              Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
              console.log(this.$t('COMMON.MSG_EXPIRED'))
            } else {
              Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
      }
    },
    exportSalesforce: function () {
      this.$store.commit('setExportFormDocID', this.formData.form_doc_id)
      router.push({path: `/process/processed`})
    },
    acceptFormDoc: async function () {
      let isSignatureValidated = this.validateSignature()
      if (isSignatureValidated && await this.formsSignatureValidate()) {
        this.updateFormDocStatus(true)
      } else {
        if (isSignatureValidated === false) {
          Vue.toasted.show(this.$t('FORMS.VALIDATE_SIGNATURE'), { icon: 'chain-broken', type: 'error' })
        } else {
          Vue.toasted.show(this.$t('Form Validations Error'), { icon: 'chain-broken', type: 'error' })
        }
      }
    },

    acceptForm: async function () {
      if (this.formData.template_id !== '-6' || this.formData.template_id !== '-16' || this.formData.template_id !== '-17') {
        let isSignatureValidated = this.validateSignature()
        let formValidations = isSignatureValidated ? await this.sfFieldValidations() : false
        if (isSignatureValidated && formValidations) {
          this.updateFormStatus()
        } else {
          if (isSignatureValidated === false) {
            Vue.toasted.show(this.$t('FORMS.VALIDATE_SIGNATURE'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('FORMS.ACCEPT_PERMISSION_ERROR'), { icon: 'chain-broken', type: 'error' })
            router.push('/process/processed')
          }
        }
      } else {
        if (this.updatedData.length > 0) {
          this.saveData(true)
        } else {
          this.updateFormStatus()
        }
      }
    },

    updateFormStatus: async function () {
      Vue.axios.patch('/forms/' + this.currentFormId + '/update_status', { }, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          let form = response.data.form
          this.formData.form_status = form.status
          Vue.toasted.show(this.$t('FORMS.MSG_ACCEPT'))
          this.get_pages()
        }).catch(error => {
          if (error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },

    get_pages () {
      return new Promise((resolve, reject) => {
        let status = 'stage_' + this.userRoleOrder
        Vue.axios.post('/form_docs/' + this.docId + '/get_unaccepted_pages', { status }, {headers: {Authorization: `Bearer ${this.idToken}`}})
          .then(response => {
            let pages = response.data.pages
            if (pages.length > 0) {
              this.goToPage(pages[0].page - 1)
            } else {
              console.log('update form docs Status')
              this.updateFormDocStatus()
            }
          })
      })
    },
    formsSignatureValidate () {
      return new Promise((resolve, reject) => {
        Vue.axios.post('/form_docs/' + this.docId + '/validate', { }, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(async response => {
            let errors = response.data.errors
            if (response.data.valid === false) {
              let isSignatureError = false
              for (let error of errors) {
                if (error.page !== this.getCurrentPage) {
                  if (this.pageErrors(error.errors) === true) {
                    isSignatureError = true
                    Vue.toasted.show('Please Approve Signature in Another Page', { icon: 'chain-broken', type: 'error' })
                    this.goToPage(error.page - 1)
                    break
                  }
                }
              }
              if (isSignatureError === false) {
                let isSfFieldValid = await this.sfFieldValidations()
                if (isSfFieldValid) {
                  resolve(true)
                } else {
                  resolve(false)
                }
              }
            } else {
              let isSfFieldValid = await this.sfFieldValidations()
              if (isSfFieldValid) {
                resolve(true)
              } else {
                resolve(false)
              }
            }
          }).catch(error => {
            console.log(error)
            if (error.response.status === 401) {
              Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
              console.log(this.$t('COMMON.MSG_EXPIRED'))
            } else {
              Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
      })
    },
    pageErrors (errors) {
      for (let error of errors) {
        if (error.type === 'Signature' && error.current_value === 'pending') {
          return true
        }
      }
    },
    sfFieldValidations () {
      this.processedDataLoaded = false
      return new Promise((resolve, reject) => {
        Vue.axios.post('/form_docs/validate_sf_fields', {id: Object.keys(this.allPageIdMap)}, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(response => {
            // if (response.data.status === 'failed') {
            //   this.salesForeceValidationError = response.data.message
            //   this.$refs.slaesForceAlertModal.show()
            //   this.processedDataLoaded = true
            //   resolve(false)
            // } else if (response.data.status === 'success') {
            //   this.processedDataLoaded = true
            //   resolve(true)
            // } else
            if (response.data.status === 'Error') {
              resolve(false)
            } else {
              resolve(true)
            }
          }).catch(error => {
            if (error.response.status === 401) {
              Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
              console.log(this.$t('COMMON.MSG_EXPIRED'))
            } else {
              this.processedDataLoaded = true
              Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
      })
    },
    updateFormDocStatus (acceptAll = false) {
      Vue.axios.patch('/form_docs/' + this.docId + '/update_status', { status: this.userRole, accept_all: acceptAll }, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          if (acceptAll) {
            Vue.toasted.show(this.$t('FORMS.MSG_ACCEPT'))
          }
          this.exportFormFlag = true
        }).catch(error => {
          if (error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },

    hideModal: function () {
      this.$refs.newFieldModal.hide()
    },

    addNewField: function () {
      let nodeId = this.processData.children.length + 1
      let newNode = {
        color_code: this.formData.top_conf_color,
        confidence: 1,
        current_value: this.newFieldValue,
        edited: true,
        id: null,
        key: this.newFieldLabel,
        map_type: 'shape',
        original_value: '',
        path: '1.0',
        pv_id: 'new_' + nodeId,
        new_record: true,
        form_id: this.id
      }

      this.processData.children.push(newNode)
      this.updatedData.push({id: newNode.pv_id, key: newNode.key, new_record: true, form_id: newNode.form_id, current_value: newNode.current_value})
      this.newFieldLabel = null
      this.newFieldValue = null
      this.$refs.newFieldModal.hide()
    },

    showExportError: function () {
      this.$refs.exportErrorModal.show()
    },

    showCompareModal: function () {
      this.$refs.compareCardsModal.show()
      this.isOpenCompareUploaded = true
    },
    onHideCompareModal () {
      this.isOpenCompareUploaded = false
    },

    editedPEV: function (entryId, entryHeader) {
      return (this.originalPEVs[entryId][entryHeader] !== this.updatedPEVs[entryId][entryHeader])
    },

    manualData: function () {
      this.fetchTemplateOptions()
      this.$refs.addDataModal.show()
    },

    fetchTemplateOptions () {
      Vue.axios.get('/template_docs/list_options', { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          this.templateOptions = response.data.template_docs
        }, error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          }
          console.log(error)
        })
    },

    handleSelectedTemp () {
      var selectedTemp = this.templateOptions.filter(temp => { return temp.value === this.selectedTemplate })[0]
      this.previewImageUrl = this.axios.defaults.baseURL.replace('/api', '') + selectedTemp.image_url
      this.fetchTemplatePageOptions()
    },

    fetchTemplatePageOptions () {
      Vue.axios.get('/template_docs/' + this.selectedTemplate + '/list_page_options', { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.templatePageOptions = res.data.templates
        })
        .catch(err => console.log(err))
    },

    handleSelectTemplatePage () {
      let selectedPage = this.templatePageOptions.filter(page => { return page.value === this.selectedTemplatePage })[0]
      this.pagePrevImgUrl = this.axios.defaults.baseURL.replace('/api', '') + selectedPage.image_url
    },
    fetchTemplateMappings () {
      Vue.axios.post('/processed_values/unmatched_processed_values', {form_ids: Object.keys(this.formData.all_processed_form_ids), template_ids: this.templatePageOptions}, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.fetchForm()
          this.showAddDataButton = false
        })
        .catch(err => console.log(err))
    },
    updateExcelData: function (event, entryId, entryHeader) {
      var updatedValue = {}
      updatedValue[entryHeader] = event.target.value
      var updatedEntry = Object.assign({}, this.updatedPEVs[entryId])
      updatedEntry = Object.assign(updatedEntry, updatedValue)
      var updatedPEV = {}
      updatedPEV[entryId] = updatedEntry
      this.updatedPEVs = Object.assign(this.updatedPEVs, updatedPEV)
      if (this.updatedPEVIds.indexOf(entryId) === -1) {
        this.updatedPEVIds = this.updatedPEVIds.slice().concat([entryId])
      }
    },

    redirectToMatchedTemplate: function () {
      router.push('/templates/' + this.formData.template_id + '?version=' + this.formData.revision_id)
    },

    updateTableData: function (event, cellValue) {
      cellValue.current_value = event.target.value
      let updateData = [{
        id: cellValue.pv_id,
        key: cellValue.key,
        new_record: cellValue.new_record,
        form_id: cellValue.form_id,
        current_value: cellValue.current_value
      }]
      this.dataBus.$emit('updateData', updateData)
    },

    hideUnhideScreen () {
      this.ishideUnhideClicked = !this.ishideUnhideClicked
      let canvas = document.getElementById('canvasShow')
      if (this.ishideUnhideClicked) {
        canvas.style.height = window.innerHeight / 2 + 'px'
        canvas.style.overflowY = 'scroll'
        canvas.style.overflowX = 'hidden'
        this.updateScrollHeight()
      } else {
        canvas.style.removeProperty('height')
        canvas.style.removeProperty('overflowY')
        this.updateScrollHeight()
      }
    },
    showOriginalImage (stat) {
      if (stat === 0) {
        this.toShowOriginalImage = true
      } else {
        this.toShowOriginalImage = false
      }
      this.createCanvas()
    }
  },

  validations: {
    invoice: {
      selectedAccount: {
        required
      },
      selectedAccountingUnit: {
        required
      },
      totalAmount: {
        required,
        minVal: minValue(0)
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.action-bar-row {
  display: inline-block;
  margin: 6px;
  text-align: center;
  .alert {
    padding: 0 50px;
    margin-bottom: 0;
  }
}
@media only screen and (min-width: 992px) {
  .scrollable-content {
    padding: 1.25rem;
    overflow: scroll;
  }
  .card-body { padding: 0 }
}
.paginate-page {
  .btn-link {
    color: white;

    &.disabled {
      color: #fdfeff;
    }
  };
  color: white;
  margin-top: 0.75rem;
}

.fa-arrow-left, .fa-arrow-right {
  font-size: 16px;
}

.fa-arrow-up,.fa-arrow-down {
  font-size: 30px;
}

.process-data .card-header div{
  padding: 2px 0;
}

.add-field-btn {
  margin-right: 3px;
  display: inline-block;
}

.card .card,
.card-header,
.card-footer {
  background-color: #EAEFF2;
}

.card-body {
  background-color: white;
}

.compare-image {
  width: 100%;
  height: auto;
  border-top-left-radius: calc(0.25rem - 1px);
  vertical-align: super;
}

.heading {
  padding: 0.26rem;
  background-color: #0e2547;
  width: 100%;
}

.heading h2 {
  font-size: 1.5rem;
  text-transform: uppercase;
  display: inline-block;
  color: white;
}

.heading h3 {
  font-size: 1.2rem;
  display: inline-block;
  color: white;
}

.compare-icon {
  display: inline-block;
  padding-right: 1rem;
}

.canvas-card .card-body {
  padding: .5rem;
  background-color: #EAEFF2;
}

.save-btn {
  font-size: 1rem;
}

.service-btn {
  font-size: 0.8rem;
  border-radius: 18px;
}

.error-acknowledgement {
  font-size: 1rem;
  color: red;
}

.excel-workbook {
  padding: 5px;
  max-height: 500px;
  overflow-y: scroll;
}

.no-excel-data {
  padding: 20px;
  text-align: center;
  background-color: #eeeeee;
  border: 5px solid white;
}

table, th, td {
  border-collapse: collapse;
}

th, td {
  padding: 8px;
  text-align: center;
  border: 1px solid white;
  font-size: 0.75rem;
}

table tr:nth-child(even) {
  background-color: #f0f6ff;
}

table tr:nth-child(odd) {
  background-color: #ffffff;
}

table th {
  background-color: #eeeeee;
}

table tr:hover {
  background-color: #eeeeee;
}

.table-input {
  border: none;
  background-color: inherit;
  text-align: center;
}

.table-input:focus {
  outline: none;
  background-color: white;
  border-bottom: 1px solid black;
}

.table-input-edited {
  color: blue;
}

.range-slider {
  max-width: 75%;
  margin: auto;
  text-align: center;
  position: relative;
  height: 6em;
  font-size: 0.8rem;
  padding: 5px;
}

.range-slider input[type=range] {
  position: absolute;
  left: 0;
  bottom: 0;
}

input[type=number]:not(#totalAmount) {
  border: 1px solid #ddd;
  text-align: center;
  font-size: 1.6em;
  -moz-appearance: textfield;
}

input[type=number]:not(#totalAmount)::-webkit-outer-spin-button,
input[type=number]:not(#totalAmount)::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type=number]:not(#totalAmount):invalid,
input[type=number]:not(#totalAmount):out-of-range {
  border: 2px solid #ff6347;
}

input[type=range] {
  -webkit-appearance: none;
  width: 100%;
}

input[type=range]:focus {
  outline: none;
}

input[type=range]:focus::-webkit-slider-runnable-track {
  background: green;
}

input[type=range]:focus::-ms-fill-lower {
  background: green;
}

input[type=range]:focus::-ms-fill-upper {
  background: green;
}

input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 5px;
  cursor: pointer;
  animate: 0.2s;
  background: green;
  border-radius: 1px;
  box-shadow: none;
  border: 0;
  margin-bottom:0px;
  margin-top:-70px;
}

input[type=range]::-webkit-slider-thumb {
  z-index: 2;
  position: relative;
  box-shadow: 0px 0px 0px #000;
  border: 1px solid #2497e3;
  height: 18px;
  width: 18px;
  border-radius: 25px;
  background: #10ac3e;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -8px;
}

.page_numbers {
  margin-top: 5px;
  margin-bottom: 15px;
}

.required {
  color: red;
}

.form-control {
  border-radius: 20px;
}

.my-custom-scrollbar {
  position: relative;
  height: 200px;
  overflow: auto;
}

.table-wrapper-scroll-y {
  display: block;
}

.model-scrollbar {
  position: relative;
  max-height: 500px;
}

.content-loader tr td {
  white-space: nowrap;
}

.modal-content .btn {
  padding-right: 8px;
  padding-left: 8px;
  border-radius: 0px;
}
.stick-table thead th {
    position: sticky;
    position: -webkit-sticky;
    top: 0;
}

.processedData {
  margin-left: 1%;
}

.save-data {
  margin-bottom: 13%;
  margin-left: 13%;
}
.error_listing {
  text-align: left;
}

.ellipsis{
  display: inline-block;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/views/forms/processForm.vue